<div class="cq-dictionary">
  <div class="title">
    <img (click)="closeDictionary()" src="/assets/icons/close-normal.svg" alt="close-modal" /> CQ Configuratior
    Dictionary
  </div>
  <div class="body">
    <div class="sort">
      <span>Sorted by</span>
      <select id="dropdown" [(ngModel)]="selectedOption" (change)="onOptionChange()">
        <option value="Grouped_Area">Grouped Area</option>
        <option value="Alphabet">Alphabet</option>
      </select>
    </div>
    <div class="accordion">
      <cq-accordion
        [items]="sortedAccordionItems"
        [isShowTitle]="false"
        [isOneOpened]="false"
        [openedTabs]="[1]"
      ></cq-accordion>
    </div>
  </div>
</div>
